<template>
  <div>
    <span>Select domain</span><br />
    <v-btn-toggle v-model="selectedDomain" class="mb-10" mandatory>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on">
            <v-icon>device_thermostat</v-icon>
          </v-btn>
        </template>
        <span>Heating</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on">
            <v-img
              src="@/assets/hot_water.png"
              width="25px"
              height="25px"
            ></v-img>
          </v-btn>
        </template>
        <span>Domestic hot water</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on">
            <v-icon>ac_unit</v-icon>
          </v-btn>
        </template>
        <span>Cooling</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on">
            <v-icon>air</v-icon>
          </v-btn>
        </template>
        <span>Ventilation</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on">
            <v-icon>emoji_objects</v-icon>
          </v-btn>
        </template>
        <span>Lighting</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on">
            <v-icon>bolt</v-icon>
          </v-btn>
        </template>
        <span>Electricity</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on">
            <v-icon>vertical_shades_closed</v-icon>
          </v-btn>
        </template>
        <span>Dynamic building envelope</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on">
            <v-icon>electric_car</v-icon>
          </v-btn>
        </template>
        <span>Electric vehicle charging</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on">
            <v-icon>dvr</v-icon>
          </v-btn>
        </template>
        <span>Monitoring and control</span>
      </v-tooltip>
    </v-btn-toggle>

    <v-form ref="form" @submit.prevent="submitForm">
      <v-row>
        <v-col>
          <v-select
            v-model="selectedDomainService"
            :items="filteredServices"
            label="Domain Service"
            item-text="description"
            item-value="name"
            :rules="[required]"
            outlined
            required
            dense
            hide-details
          ></v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-select
            v-model="level_value"
            :items="level_values"
            label="Level Value"
            :disabled="levelValueDisabled"
            outlined
            required
            dense
            hide-details
          ></v-select>
        </v-col>
        <v-col>
          <v-select
            v-model="additional_level_value"
            :items="level_values"
            label="Additional Level Value"
            :disabled="additionalLevelDisabled"
            outlined
            required
            dense
            hide-details
          ></v-select>
        </v-col>
        <v-col>
          <v-text-field
            v-model="additional_share"
            label="Additional Share"
            type="number"
            step="any"
            max="1"
            min="0"
            :disabled="additionalShareDisabled"
            outlined
            dense
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-select
            v-model="selectedDomainPresence"
            :items="domainPresenceItems"
            label="Domain Presence"
            item-text="label"
            item-value="name"
            outlined
            required
            dense
            hide-details
          ></v-select>
        </v-col>
        <v-col>
          <v-select
            v-model="triage"
            :items="options"
            item-text="label"
            item-value="value"
            label="Triage"
            outlined
            required
            dense
            hide-details
          ></v-select>
        </v-col>
        <v-col>
          <v-select
            v-model="service_applicable"
            :items="options"
            item-text="label"
            item-value="value"
            label="Service applicable"
            outlined
            required
            dense
            hide-details
            :disabled="serviceApplicableDisabled"
          ></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-spacer></v-spacer>

        <v-col cols="2">
          <v-btn color="#4d51c5" text @click="closeDialog">Cancel</v-btn>
        </v-col>
        <v-col offset="1" cols="2">
          <v-btn type="submit" color="#4d51c5" text>Save</v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import utility from "../utility/utility";
import "material-design-icons-iconfont/dist/material-design-icons.css";

export default {
  props: {},
  data() {
    return {
      domainItems: [],
      domainServiceItems: [],
      domainPresenceItems: [],
      level_values: [0, 1, 2, 3, 4],
      options: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],

      selectedDomainService: null,
      selectedDomainPresence: "PRESENT",
      level_value: 1,
      triage: true,
      service_applicable: true,
      additional_level_value: 1,
      additional_share: 0.5,

      maxLevelValue: 4,

      nonNegative: (v) => {
        if (v < 0) return "Please enter a positive number";
        return true;
      },
      levelValueDisabled: false,
      serviceApplicableDisabled: false,
      additionalLevelDisabled: false,
      additionalShareDisabled: false,
      selectedDomain: 0,
      filteredServices: [],
      required: (value) => !!value || "This field is required",
    };
  },
  mounted: function () {
    this.dbData = JSON.parse(sessionStorage.getItem("dbData"));
    this.setCodebookData();
    this.filterServices("HEATING");
  },

  methods: {
    closeDialog() {
      this.$emit("closeDialog");
    },
    submitForm() {
      if (this.$refs.form.validate()) {
        let body = {
          domain_service: this.selectedDomainService,
          domain_presence: this.selectedDomainPresence,
          level_value: this.level_value,
          triage: this.triage,
          service_applicable: this.service_applicable,
          additional_level_value: this.additional_level_value,
          additional_share: this.additional_share,
        };
        this.$emit("submitForm", body);
        this.closeDialog();
      }
    },
    setCodebookData: function () {
      this.service_domain_lookup = this.dbData.service_domain_lookup;
      this.service_description_lookup = this.dbData.service_description_lookup;
      this.domainServiceItems = this.getTable("domain_service");
      this.domainPresenceItems = this.getTable("domain_presence");
      this.domainServiceItems.forEach(
        (item) =>
          (item.description = this.service_description_lookup[item.name])
      );
      this.domainItems = this.dbData.enum_constants_lookup["domain"];
    },
    getTable: function (table) {
      return this.dbData.enum_constants_lookup[table].map((item, index) => {
        return {
          id: index,
          name: item,
          label: utility.convertStrToLabel(item),
        };
      });
    },
    setFormForDomainServicePresence: function (present) {
      this.service_applicable = present;
      this.serviceApplicableDisabled = !present;
      this.setFormForServiceApplicable(present);
    },
    setFormForServiceApplicable: function (applicable) {
      this.levelValueDisabled = !applicable;
      this.additionalShareDisabled = !applicable;
      this.additionalLevelDisabled = !applicable;
      this.level_value = applicable ? 1 : 0;
      this.additional_level_value = applicable ? 1 : 0;
      this.additional_share = applicable ? 0.5 : 0;
    },
    filterServices: function (domainName) {
      this.filteredServices = this.domainServiceItems.filter(
        (domainService) =>
          this.service_domain_lookup[domainService.name] === domainName
      );
    },
  },

  watch: {
    selectedDomainService: function (value) {
      const dbData = JSON.parse(sessionStorage.getItem("dbData"));
      this.maxLevelValue = dbData.level_value_upper_bound_lookup[value];
      let levelValues = [];
      for (let i = 0; i <= this.maxLevelValue; i++) {
        levelValues.push(i);
      }
      this.level_values = levelValues;
      if (!this.levelValueDisabled) {
        this.level_value = 1;
        this.additional_level_value = 1;
      }
    },
    selectedDomainPresence: function (value) {
      if (value !== "PRESENT") {
        this.setFormForDomainServicePresence(false);
      } else {
        this.setFormForDomainServicePresence(true);
      }
    },
    service_applicable: function (value) {
      this.setFormForServiceApplicable(value);
    },
    additional_share: function (value) {
      value = parseFloat(value);
      if (
        this.selectedDomainPresence === "PRESENT" &&
        this.service_applicable === true
      ) {
        if (value === 0) {
          this.additional_level_value = 0;
          this.additionalLevelDisabled = true;
          this.levelValueDisabled = false;
        } else if (value === 1) {
          this.level_value = 0;
          this.levelValueDisabled = true;
          this.additionalLevelDisabled = false;
        } else if (0 < value && value < 1) {
          this.additionalLevelDisabled = false;
          this.levelValueDisabled = false;
        }
      }
    },
    selectedDomain: function (value) {
      this.filterServices(this.domainItems[value]);
    },
  },
};
</script>

<style scoped></style>
